module.exports = __webpack_public_path__ + "img/couverture.1.lmda.bandeau.208.0c88f67d.jpg";